import React, { memo } from "react";
import useStyles from "./styles";

import { Grid, Button } from "@material-ui/core";

const FooterMenuItem = props => {
	const classes = useStyles();

	const { menu, handleClickMenu, checkLinkActive, quanlityMenu } = props;

	const isActive = checkLinkActive(menu.link);

	return (
		menu?.isShow && (
			<Button
				item
				// xs={12 / quanlityMenu}
				// classes={{ root: classes.menu }}
				classes={{ label: classes.label, root: classes.menu }}
				style={{ width: `${100 / quanlityMenu}%` }}
				onClick={() => handleClickMenu(menu.link)}
			>
				<Grid
					className={
						isActive ? classes.iconActive : classes.icNonActive
					}
					container
					justifyContent="center"
					alignItems="center"
				>
					<img
						src={isActive ? menu.iconActive : menu.icon}
						alt={isActive ? menu.iconActive : menu.icon}
						width={isActive ? 30 : 20}
						height={isActive ? 30 : 20}
					/>
				</Grid>
				<Grid
					className={isActive ? classes.colorActive : classes.color}
				>
					{menu.title}
				</Grid>
			</Button>
		)
	);
};

export default memo(FooterMenuItem);
